export default {
  referToFriend: "Refer To Friend",
  aboutMe: "About Me",
};
